/* RESPONSIBLE TEAM: team-standalone */
import { ReactRoute } from 'embercom/lib/react-route';
import Route from '@ember/routing/route';

class PlatformSettingsRoute extends Route {
  reactEnabled() {
    return true;
  }

  buildRouteInfoMetadata() {
    return { responsibleTeam: 'team-standalone', react: true };
  }
}

export default ReactRoute(PlatformSettingsRoute);
